import { schema } from "normalizr";

const stopwatch = new schema.Entity(`stopwatches`);
const arrayOfStopwatches = [stopwatch];

export { stopwatch, arrayOfStopwatches };
